import PropTypes from "prop-types";
import Button from "../../Button";
import {useTranslation} from "next-i18next";

const EditorPanelButton = ({text, onClick, isTab, icon: Icon}) => {
  const {t} = useTranslation();

  return (
    <Button
      className="buttons-panel__button pdf-editor__edit-block" size="sm"
      disabled={isTab} onClick={onClick}>
      {Icon && <Icon className="buttons-panel__button-logo"/>}
      {text && t(`convert-and-edit:editor.${text}`)}
    </Button>
  );
};

EditorPanelButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  isTab: PropTypes.bool,
  icon: PropTypes.elementType,
};

export default EditorPanelButton;
